import { baseApi } from '@/config/axios';
import {
  AISessionResponse,
  AIChatHistoryResponse,
  AIChatSendMessageParams,
  AIChatSendMessageResponse,
} from '@/types/api/aiChat';

/**
 * AIセッション取得/作成
 * セッションキー（ログイン識別子）は認証済み顧客からサーバ側が導出するため送らない
 */
export const getAISessionApi = (): Promise<AISessionResponse> =>
  baseApi.get('/v1/customer/ai/session');

/**
 * 対話履歴取得
 * 常に最新側から limit 件返る。遡る場合は before_id に
 * 画面が持っている一番古いメッセージのIDを渡す
 */
export const getAIChatHistoryApi = (params: {
  limit?: number;
  before_id?: number;
}): Promise<AIChatHistoryResponse> =>
  baseApi.get('/v1/customer/ai/history', { params });

/** メッセージ送信（HTTP fallback） */
export const postAIChatMessageApi = (
  params: AIChatSendMessageParams,
): Promise<AIChatSendMessageResponse> =>
  baseApi.post('/v1/customer/ai/chat', params);
